import notificationsBellImage from 'assets/images/notifications/notifications-bell.png';
import Loader from 'components/Loader';
import RawText from 'components/RawText';
import { getUserName } from 'model/User';
import React, { FC, memo } from 'react';
import { getUserType } from 'utils/getUserType';

import { useConnect } from './connect';
import {
  ActivityAction,
  ActivityAvatar,
  ActivityItem,
  ActivityLink,
  ActivityListContainer,
  ActivityText,
  DropdownPanel,
  EmptyStateDescription,
  EmptyStateTitle,
  LoaderContainer,
  NotificationBellImage,
  NotificationsBellImageContainer,
  PanelTitle,
  SeeAllLink,
  SeeAllLinkContainer,
} from './styles';
import { Props } from './types';

const ActivityList: FC<Props> = ({ handleClose }) => {
  const { isLoading, notifications } = useConnect();

  return (
    <DropdownPanel>
      <PanelTitle>Activity</PanelTitle>

      {isLoading ? (
        <LoaderContainer>
          <Loader size={20} />
        </LoaderContainer>
      ) : notifications.length > 0 ? (
        <ActivityListContainer>
          {notifications.map(({ id, message, targetObject, user }) => {
            const normalizedMessage = message.toLowerCase();
            const isFollowingYouNotification = normalizedMessage.includes(
              'following you',
            );
            const isStartedFollowingNotification = normalizedMessage.includes(
              'you started following',
            );
            const subject = isFollowingYouNotification
              ? user.firstName
              : getUserName(user);
            const showSubject = !isStartedFollowingNotification;
            const showTargetObject =
              !!targetObject && !isFollowingYouNotification;
            const targetObjectUrl =
              isStartedFollowingNotification &&
              targetObject?.model === 'user' &&
              targetObject?.id
                ? `/members/${targetObject.id}`
                : targetObject?.url;

            return (
              <ActivityItem key={id}>
                <ActivityAvatar variant={getUserType(user)} src={user.avatar} />
                <ActivityText>
                  {showSubject && (
                    <ActivityLink
                      to={`/members/${user.id}`}
                      onClick={handleClose}
                    >
                      {subject}
                    </ActivityLink>
                  )}
                  {showSubject && ' '}
                  <ActivityAction>{message}</ActivityAction>
                  {showTargetObject && targetObjectUrl && (
                    <>
                      {' '}
                      <ActivityLink to={targetObjectUrl} onClick={handleClose}>
                        <RawText content={targetObject.title} />
                      </ActivityLink>
                    </>
                  )}
                </ActivityText>
              </ActivityItem>
            );
          })}
        </ActivityListContainer>
      ) : (
        <>
          <NotificationsBellImageContainer>
            <NotificationBellImage
              src={notificationsBellImage}
              alt="Notifications bell"
            />
          </NotificationsBellImageContainer>

          <EmptyStateTitle>You're all caught up</EmptyStateTitle>

          <EmptyStateDescription>
            New activity will appear here as soon as there's something to
            review.
          </EmptyStateDescription>

          <SeeAllLinkContainer>
            <SeeAllLink
              to="/members/me/contributions/recent-activity"
              onClick={handleClose}
            >
              See all activity
            </SeeAllLink>
          </SeeAllLinkContainer>
        </>
      )}
    </DropdownPanel>
  );
};

export default memo(ActivityList);
